import { useTheme } from "@mui/material";
import Head from "next/head";
import { useClientBookingContext } from "@/contexts/clientBookingContext";
import { getAddressString } from "@/utils";
import MetaPixel from "./metaPixel";

export default function BookingPageHead() {
  const theme = useTheme();
  const { medspaData: medspaInfo } = useClientBookingContext();
  const title = `Book with ${medspaInfo.name}`;
  const addressString = getAddressString(medspaInfo.address);
  const description = medspaInfo.address?.addressLine1
    ? `Find us at ${addressString}`
    : "Book now";

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />

        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />

        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />

        {/* Prevent search engines from indexing this page */}
        <meta name="robots" content="noindex"></meta>

        <meta name="theme-color" content={theme.palette.primary.main} />
      </Head>

      {/* Meta Pixel Code - must be outside head */}
      {medspaInfo.metaPixelId && <MetaPixel id={medspaInfo.metaPixelId} />}
    </>
  );
}
